import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BlogServices from "../../services/BlogServices";
import Footer from "./Common/footer";
import moment from "moment";

const BlogDetails = () => {
    const { title } = useParams(); // Get the blog title from the URL
    const formattedTitle = title ? decodeURIComponent(title).replace(/-/g, " ") : "";
    const [blog, setBlog] = useState(null); // Blog data state
    const [isLoading, setIsLoading] = useState(true); // Loading state
    const [error, setError] = useState(null); // Error state

    useEffect(() => {
        if (!formattedTitle) return; 
    // Fetch blog data by title
    const fetchBlog = async () => {
        try {
            const response = await BlogServices.getBlogByTitle(formattedTitle);
            if (response?.data?.length > 0) {
                setBlog(response?.data[0]);
            } else {
                setError("Blog not found");
            }
        } catch (err) {
            console.error("Error fetching blog:", err);
            setError("Error loading blog details");
        } finally {
            setIsLoading(false);
        }
    };

    fetchBlog();
}, [formattedTitle]);

    // If loading, show loading message
    if (isLoading) return <div>Loading...</div>;

    // If there's an error, show error message
    if (error) return <div>{error}</div>;

    // If blog is not loaded yet, return nothing
    if (!blog) return null;

    return (
        <>
            <section className="notification-section blog-details-section">
                <div className="container">
                    <div className="blog-outer">
                        <h3 style={{ color: "white" }} className="banner-heading">Blog Details</h3>
                    </div>
                </div>
            </section>
            <section className="all-blog-section">
                <div className="container">
                    <div className="breadcrumb-outer">
                        <ul className="breadcrumb">
                            <li><a href="/">Home</a></li>
                            <li><a href="/blog">Blog</a></li>
                            <li>Blog Details</li>
                        </ul>
                    </div>

                    <div className="notification-inner">
                        <div className="row g-4">
                            {blog?.images?.length > 0 ? (
                                <div className="col-md-12">
                                    <div className="blog-details-img-outer">
                                        {blog?.images.map((image, index) => (
                                            <img
                                                key={index}
                                                src={`${process.env.REACT_APP_URL || ''}${image}`}
                                                alt={`Blog Image ${index + 1}`}
                                                className="blog-img"
                                            />
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div style={{ color: "red", fontWeight: "bold" }}>No images available</div>
                            )}
                        </div>

                        <div className="details-heading-outer">
                            <div className="heading-outer d-flex">
                                <div className="main-heading-outer">
                                    <h3 className="main-heading blog-main-heading" style={{ fontSize: 28, marginBottom: 10 }}>
                                        {blog?.title || "Title not available"}
                                    </h3>
                                    <p className="sub-heading" style={{ marginBottom: 10 }}>
                                        {blog?.publishedDate || blog?.createdAt
                                            ? moment(blog.publishedDate || blog.createdAt).format("MMMM D, YYYY")
                                            : "Date not available"}
                                        {" | By "}
                                        {blog?.author || "Unknown Author"}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <div className="blog-content">
                                    {/* Render content with HTML tags preserved */}
                                    <div
                                        dangerouslySetInnerHTML={{ __html: blog?.content }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default BlogDetails;
